'use client'

import { env } from '@/env'
import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { useEffect, useState } from 'react'

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  const [isPosthogReady, setIsPosthogReady] = useState(false)
  useEffect(() => {
    posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: env.NEXT_PUBLIC_POSTHOG_HOST,
      capture_pageview: false,
      capture_dead_clicks: false,
      person_profiles: "always",
      loaded: () => setIsPosthogReady(true)
    })
  }, [])

  return isPosthogReady ? (
    <PHProvider client={posthog}>
      {children}
    </PHProvider>
  ) : (
    <div>Loading...</div>
  )
}